module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }